import React, { useState, useEffect, useRef, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import negociationService from '../services/negociationService';
import '../styles/ChatModal.css';

const ChatModal = ({ product, onClose }) => {
  const { user } = useContext(AuthContext);
  const [negociationId, setNegociationId] = useState(null);
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const bottomRef = useRef(null);

  const loadMessages = async (id) => {
    const res = await negociationService.detail(id);
    const echanges = res.data.data?.echanges || [];
    setMessages(echanges);
  };

  useEffect(() => {
    negociationService.creerContact(product.id)
      .then(res => {
        const id = res.data.data?.negociation_id;
        setNegociationId(id);
        return loadMessages(id);
      })
      .catch(() => setError("Impossible d'ouvrir la conversation"))
      .finally(() => setLoading(false));
  }, [product.id]);

  useEffect(() => {
    if (!negociationId) return;
    const iv = setInterval(() => loadMessages(negociationId).catch(() => {}), 5000);
    return () => clearInterval(iv);
  }, [negociationId]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const handleSend = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setSending(true);
    try {
      await negociationService.envoyerMessage(negociationId, text.trim());
      setText('');
      await loadMessages(negociationId);
    } catch (e) {
      setError(e.response?.data?.message || 'Erreur envoi');
    } finally {
      setSending(false);
    }
  };

  const formatTime = (d) => new Date(d).toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });

  return (
    <div className="chat-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="chat-modal">
        <div className="chat-header">
          <div className="chat-header-info">
            <span className="chat-product-name">{product.titre}</span>
            <span className="chat-type-badge">
              {product.type_vente === 'encheres' ? 'Enchère' : 'Contact vendeur'}
            </span>
          </div>
          <button className="chat-close" onClick={onClose}>✕</button>
        </div>

        <div className="chat-messages">
          {loading && <div className="chat-loading">Chargement...</div>}
          {error   && <div className="chat-error">{error}</div>}
          {!loading && messages.map(msg => {
            const isMe = msg.auteur_id === user?.id;
            return (
              <div key={msg.id} className={`chat-msg ${isMe ? 'chat-msg-me' : 'chat-msg-other'}`}>
                {!isMe && <span className="chat-sender">{msg.auteur_prenom} {msg.auteur_nom}</span>}
                {msg.action === 'contact' ? (
                  <div className="chat-system">{msg.message}</div>
                ) : (
                  <div className="chat-bubble">
                    {msg.message && <p>{msg.message}</p>}
                  </div>
                )}
                <span className="chat-time">{formatTime(msg.created_at)}</span>
              </div>
            );
          })}
          <div ref={bottomRef} />
        </div>

        <form className="chat-input-area" onSubmit={handleSend}>
          <div className="chat-text-row">
            <input type="text" className="chat-text-input" placeholder="Votre message..."
              value={text} onChange={e => setText(e.target.value)} />
            <button type="submit" className="chat-send-btn" disabled={sending || !text.trim()}>
              {sending ? '...' : 'Envoyer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChatModal;
